
export default {
  props: {
    data: [],
  },
  computed:{
    comData(){
      return this.data.filter(item => item.is_show)
    }
  }
};
